
import React, { useState } from "react";
import evaluateImg from "../../../assets/evaluate.png";

export function renderNetraaAPMReleaseNotes() {
  return <RenderNetraaAPMReleaseNotes />;
}

function RenderNetraaAPMReleaseNotes() {
  const [zoomImage, setZoomImage] = useState(null);
  const [zoomVideo, setZoomVideo] = useState(null);
  return (
    <div>
      <main className="transition-opacity duration-300">
        <div className="mx-auto">
          {/* Hero */}
          <section className="relative scroll-mt-24" id="overview">
            <div className="">
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
                <span className="h-2 w-2 rounded-full bg-orange-500" />
                Release Notes 2026.04
              </div>

              <div className="flex items-center justify-between gap-4">
                <h1 className="text-3xl font-black tracking-tight sm:text-4xl">
                  <span className="bg-gradient-to-r from-orange-500 via-red-500 to-rose-600 bg-clip-text text-transparent">
                    Netraa APM Release Notes
                  </span>
                </h1>
              </div>
              <p className="mt-4 text-base leading-7 text-slate-600 dark:text-slate-300 sm:text-lg">
                Latest updates across application monitoring, infrastructure observability,
                intelligent analytics, and data ingestion frameworks — designed for clarity,
                performance, and a more polished experience.
              </p>

              <div className="mt-8 grid gap-4 sm:grid-cols-3">
                {[
                  {
                    title: "Intelligence & Automation",
                    description:
                      "Advanced alerting and lifecycle-aware evaluation for smarter operations.",
                  },
                  {
                    title: "Usability & Flexibility",
                    description:
                      "Dynamic dashboards, customizable widgets, and a cleaner, faster UI.",
                  },
                  {
                    title: "Stronger Coverage",
                    description:
                      "Expanded monitoring across infrastructure, Oracle database, and licensing.",
                  },
                ].map((pill, idx) => (
                  <div
                    key={pill.title}
                    className="group rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg dark:border-white/10 dark:bg-white/5"
                  >
                    <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-500 text-sm font-bold text-white shadow-md shadow-orange-500/25">
                      0{idx + 1}
                    </div>
                    <h3 className="text-sm font-semibold text-slate-900 dark:text-white">
                      {pill.title}
                    </h3>
                    <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-400">
                      {pill.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="mt-10 w-full scroll-mt-24" id="analytics">
            <div className="mx-auto">
              <h4 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
                Release Analytics
              </h4>

              <div
                className="
      glass-card
      rounded-2xl
      border border-slate-200 dark:border-white/10
      bg-white/90 dark:bg-white/5
      p-5 sm:p-6
      backdrop-blur-xl
      transition-all duration-500
      hover:-translate-y-1 hover:shadow-2xl
    "
              >
                {/* Stats */}
                <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
                  {[
                    { label: "Modules Updated", value: "6" },
                    { label: "New Features", value: "6" },
                    { label: "Security Patches", value: "02" },
                    { label: "Impact Score", value: "9.0" },
                  ].map((item, i) => (
                    <div
                      key={i}
                      className="
              rounded-xl
              border border-slate-200 dark:border-white/10
              bg-white dark:bg-white/5
              p-3
              shadow-sm
              transition-all duration-300
              hover:-translate-y-1 hover:scale-[1.02] hover:shadow-md
            "
                    >
                      <div className="mb-1 text-[11px] text-slate-500 dark:text-slate-400">
                        {item.label}
                      </div>

                      <div
                        className="
              text-lg font-bold
              text-orange-600
              dark:bg-gradient-to-r dark:from-orange-500 dark:to-rose-600
              dark:bg-clip-text dark:text-transparent
            "
                      >
                        {item.value}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Progress */}
                <div className="space-y-4">
                  {/* Deployment */}
                  <div>
                    <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
                      <span>Deployment Readiness</span>
                      <span className="font-semibold text-orange-500">96%</span>
                    </div>

                    <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                      <div
                        className="
              h-full w-[96%]
              bg-gradient-to-r from-orange-500 to-rose-600
              shadow-[0_0_8px_rgba(255,120,120,0.4)]
              transition-all duration-700
            "
                      />
                    </div>
                  </div>

                  {/* Health */}
                  <div>
                    <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
                      <span>Health Meter</span>
                      <span className="font-semibold text-rose-500">Optimal</span>
                    </div>

                    <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                      <div
                        className="
              h-full w-full
              bg-gradient-to-r from-orange-500 to-rose-600
              shadow-[0_0_8px_rgba(255,120,120,0.4)]
              transition-all duration-700
            "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Release details */}
          <section className="mb-12 mt-12">
            <h2 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
              Release Details
            </h2>

            <div className="overflow-x-auto rounded-2xl border border-slate-200 dark:border-white/10">
              <table className="w-full text-left text-sm">
                <thead className="bg-slate-50 dark:bg-white/5">
                  <tr>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                      Release Date
                    </th>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                      Release Type
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-slate-200 dark:divide-white/10">
                  <tr className="bg-white dark:bg-transparent">
                    <td className="px-5 py-4 font-medium text-orange-600 dark:text-orange-400">
                      22nd April 2026
                    </td>
                    <td className="px-5 py-4 text-slate-700 dark:text-slate-300">
                      Enhancements & Fixes
                    </td>
                  </tr>

                  <tr>
                    <td className="px-5 py-4 font-medium text-slate-500 dark:text-slate-400">
                      Organization
                    </td>
                    <td
                      className="px-5 py-4 font-medium text-slate-900 dark:text-white"
                      colSpan="2"
                    >
                      ApMoSys Products Pvt Ltd
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Introduction */}
          <section className="scroll-mt-24 px-0 py-4" id="intro">
            <div className="rounded-3xl border border-orange-200/70 bg-gradient-to-br from-orange-50 via-white to-white p-6 shadow-sm dark:border-orange-500/15 dark:from-orange-500/10 dark:via-slate-950/30 dark:to-slate-950/30">
              <div className="mb-4 flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 text-white shadow-lg shadow-orange-500/25">
                  ✦
                </div>
                <div>
                  <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
                    Introduction
                  </h2>
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    What this release brings to the platform.
                  </p>
                </div>
              </div>

              <p className="text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
                We are pleased to announce the latest release of Netraa APM, delivering
                significant advancements across application monitoring, infrastructure
                observability, intelligent analytics, and data ingestion frameworks.
              </p>

              <div className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
                {[
                  "Advanced alerting",
                  "Dynamic dashboards",
                  "Improved UI/UX",
                  "Stronger monitoring and licensing",
                ].map((item) => (
                  <div
                    key={item}
                    className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 shadow-sm dark:border-white/10 dark:bg-slate-900/50 dark:text-slate-200"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Enhancements */}
          <section className="scroll-mt-24 px-0 py-8" id="enhancements">
            <div className="mb-6 flex items-end justify-between gap-4">
              <div>
                <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
                  Key Enhancements
                </h2>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  Core improvements grouped by focus area.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {[
                {
                  title: "Infrastructure & Database Monitoring",
                  items: [
                    "Enhanced Windows support in infrastructure plugins for services, processes, and disk",
                    "Improved accuracy in infrastructure monitoring CPU calculation in AOP",
                  ],
                },
                {
                  title: "Role-Based Access Control (RBAC)",
                  items: ["Client–Application License Mapping"],
                },
                {
                  title: "Alerting & Evaluation Engine Enhancements",
                  items: [
                    "Introduced sampling-based and duration-based alert evaluation",
                    "Implemented alert lifecycle management (OPEN / CLOSED states)",
                  ],
                },
                {
                  title: "Dynamic Dashboard & UI Improvements",
                  items: [
                    "Fully dynamic dashboards with configurable widgets",
                    "Support for KPI, charts, and tabular visualizations",
                    "KPI operations: min, max, avg",
                    "Custom dashboard layout saving",
                    "UI enhancements: search, sorting, pagination, and inline editing",
                  ],
                },
                {
                  title: "Licensing (SaaS & On-Premise Enablement)",
                  items: [
                    "Designed flexible SaaS and On-Prem licensing architecture",
                    "Supported licensing models: module-based, user-based, and full-stack",
                    "Implemented license encryption for enhanced security",
                    "Added expiry notifications and renewal workflows",
                    "Improved licensing UI and backend performance",
                  ],
                },
                {
                  title: "Oracle Monitor Agent – Performance & Health Tracker",
                  items: [
                    "Comprehensive monitoring of slow queries",
                    "Database locks monitoring",
                    "Key performance metrics tracking",
                  ],
                },
              ].map((item, i) => {
                if (
                  item.title === "Role-Based Access Control (RBAC)" ||
                  item.title === "Alerting & Evaluation Engine Enhancements"
                ) {
                  return (
                    <article
                      key={item.title}
                      className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900/60"
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-500 text-sm font-bold text-white shadow-md shadow-orange-500/20">
                          {i + 1}
                        </div>

                        <div className="min-w-0 flex-1">
                          <h3 className="text-base font-bold text-slate-900 dark:text-white">
                            {item.title}
                          </h3>

                          {item.title === "Role-Based Access Control (RBAC)" ? (
                            <>
                              <div className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
                                <p>
                                  Introducing{" "}
                                  <span className="font-semibold text-slate-900 dark:text-white">
                                    Client Creation and Application Mapping
                                  </span>{" "}
                                  for streamlined licensing management, enabling efficient client
                                  onboarding, centralized application association, and simplified
                                  license administration across the platform.
                                </p>

                                <p className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-orange-600 dark:text-orange-400">
                                  <span className="h-2 w-2 rounded-full bg-orange-500"></span>
                                  How to create a client and map its license?
                                </p>
                              </div>

                              <div className="mt-5">
                                <h4 className="text-sm font-semibold text-slate-900 dark:text-white">
                                  Overview
                                </h4>
                                <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
                                  This section explains how to create a client in Netraa APM and map
                                  applications to that client for licensing management.
                                </p>
                              </div>

                              <div className="mt-6">
                                <h4 className="text-sm font-semibold text-slate-900 dark:text-white">
                                  1. Prerequisites
                                </h4>

                                <ul className="mt-3 space-y-2">
                                  {[
                                    "Administrative access to Netraa APM",
                                    "Client Name",
                                    "Domain",
                                    "Status",
                                    "Email ID",
                                    "Desired retention period",
                                    "Available licensing models configured in the system",
                                  ].map((point) => (
                                    <li
                                      key={point}
                                      className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
                                    >
                                      <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-orange-500" />
                                      <span>{point}</span>
                                    </li>
                                  ))}
                                </ul>
                              </div>

                              <div className="mt-6">
                                <h4 className="text-sm font-semibold text-slate-900 dark:text-white">
                                  2. Creating a Client
                                </h4>
                                <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                                  Create a new client from Admin Config → Client.
                                </p>

                                <ol className="mt-3 space-y-2">
                                  {[
                                    "Log in to Netraa APM using administrator credentials.",
                                    "Navigate to Admin Config.",
                                    "Select Client.",
                                    "Click the + ADD CLIENT button in the top-right corner.",
                                    "Enter Client Name, Domain, Status, Email ID, and Retention Period.",
                                    "Click Save Client to create the client successfully.",
                                  ].map((point, idx) => (
                                    <li
                                      key={point}
                                      className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
                                    >
                                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-700 dark:bg-white/10 dark:text-slate-200">
                                        {idx + 1}
                                      </span>
                                      <span>{point}</span>
                                    </li>
                                  ))}
                                </ol>

                                <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-100">
                                  <p className="font-semibold">Notes</p>
                                  <p className="mt-1">
                                    Ensure the Client Name is unique to avoid duplicate entries.
                                  </p>
                                  <p>Verify all client details before saving the configuration.</p>
                                </div>

                                <p className="mb-2 mt-3 text-xs text-slate-500">
                                  Client Creation Demo
                                </p>
                                <video
                                  className="w-25 h-45 mt-3 cursor-zoom-in object-cover object-top"
                                  autoPlay
                                  loop
                                  muted
                                  playsInline
                                  preload="metadata"
                                  onClick={() => setZoomVideo("/videos/video 1.mp4")}
                                >
                                  <source src="/videos/video 1.mp4" type="video/mp4" />
                                </video>
                              </div>

                              <div className="mt-6">
                                <h4 className="text-sm font-semibold text-slate-900 dark:text-white">
                                  3. Mapping Applications to a Client
                                </h4>
                                <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                                  Map applications for licensing and monitoring after the client is created.
                                </p>

                                <ol className="mt-3 space-y-2">
                                  {[
                                    "Log in to Netraa APM and navigate to Admin Config → Client.",
                                    "Click Client Application Mapping.",
                                    "Select + New Mapping.",
                                    "Choose the required client from the dropdown list.",
                                    "Select the desired licensing model for the application(s).",
                                    "Review the configuration and click Save to apply the mapping.",
                                  ].map((point, idx) => (
                                    <li
                                      key={point}
                                      className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
                                    >
                                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-700 dark:bg-white/10 dark:text-slate-200">
                                        {idx + 1}
                                      </span>
                                      <span>{point}</span>
                                    </li>
                                  ))}
                                </ol>

                                <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-100">
                                  <p className="font-semibold">Notes</p>
                                  <p className="mt-1">
                                    Ensure the correct licensing model is selected before saving.
                                  </p>
                                  <p>Application mappings can be updated later if required.</p>
                                </div>

                                <p className="mb-2 mt-3 text-xs text-slate-500">
                                  Application Mapping Demo
                                </p>
                                <video
                                  className="w-25 h-45 mt-3 cursor-zoom-in object-cover object-top"
                                  autoPlay
                                  loop
                                  muted
                                  playsInline
                                  preload="metadata"
                                  onClick={() => setZoomVideo("/videos/Client Mapping.mp4")}
                                >
                                  <source src="/videos/Client Mapping.mp4" type="video/mp4" />
                                </video>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
                                <p>
                                  You can view and manage all your problem alerts from a centralized
                                  and dynamic dashboard in Netraa APM.
                                </p>
                              </div>

                              <div className="mt-5">
                                <h4 className="text-sm font-semibold text-slate-900 dark:text-white">
                                  Steps to Access Problems Dashboard
                                </h4>

                                <ol className="mt-3 space-y-2">
                                  {[
                                    "Log in to Netraa APM.",
                                    "From the left-side navigation menu, open the Alerts & Problems section.",
                                    "Click on Problems to explore all active and historical problem alerts.",
                                  ].map((point, idx) => (
                                    <li
                                      key={point}
                                      className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
                                    >
                                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-700 dark:bg-white/10 dark:text-slate-200">
                                        {idx + 1}
                                      </span>
                                      <span>{point}</span>
                                    </li>
                                  ))}
                                </ol>

                                <p className="mt-4 text-sm leading-6 text-slate-600 dark:text-slate-300">
                                  The Problems dashboard provides a comprehensive view of detected issues,
                                  helping you monitor, analyze, and respond to incidents efficiently.
                                </p>
                                {/* Visible image */}
                              <img
                                src={evaluateImg}
                                alt="Problems Dashboard"
                                className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
                                onClick={() => setZoomImage(evaluateImg)}
                              /> 

                              {/* Zoom modal */}
                              {zoomImage && (
                                <div
                                  className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
                                  onClick={() => setZoomImage(null)}
                                >
                                  <img
                                    src={zoomImage}
                                    alt="Zoomed Preview"
                                    className="max-w-[95vw] max-h-[90vh] object-contain transition-all duration-300"
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </div>
                              )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </article>
                  );
                }

                return (
                  <article
                    key={item.title}
                    className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900/60"
                  >
                    <div className="flex items-start gap-4">
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-500 text-sm font-bold text-white shadow-md shadow-orange-500/20">
                        {i + 1}
                      </div>
                      <div className="min-w-0">
                        <h3 className="text-base font-bold text-slate-900 dark:text-white">
                          {item.title}
                        </h3>
                        <ul className="mt-3 space-y-2">
                          {item.items.map((point) => (
                            <li
                              key={point}
                              className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
                            >
                              <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-orange-500" />
                              <span>{point}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>

            {zoomVideo && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
                onClick={() => setZoomVideo(null)}
              >
                <video
                  className="max-h-[90vh] max-w-[90vw] rounded-lg shadow-2xl"
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls
                  onClick={(e) => e.stopPropagation()}
                >
                  <source src={zoomVideo} type="video/mp4" />
                </video>
              </div>
            )}
          </section>

          {/* Impact */}
          <section className="scroll-mt-24 py-6" id="impact">
            <div className="">
              <h2 className="text-2xl font-bold text-slate-900 dark:text-white">
                Impact & Business Value
              </h2>
              <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                The outcomes this release is designed to unlock.
              </p>

              <ul className="mt-6 space-y-4">
                {[
                  "Enhanced monitoring coverage across infrastructure and database",
                  "Improved operational efficiency through smarter alert evaluation and lifecycle management",
                  "Greater user flexibility with dynamic dashboards and configurable visualizations",
                  "Stronger security and governance with expanded licensing and RBAC capabilities",
                  "Better overall user experience through UI improvements and faster backend performance",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-1 h-2 w-2 rounded-full bg-orange-500" />
                    <span className="text-sm leading-6 text-slate-600 dark:text-slate-300">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          {/* Notes + Summary */}
          <section className="py-8">
            <div className="grid gap-8 lg:grid-cols-2">
              {/* Notes (clean list, no heavy boxes) */}
              <div>
                <h2 className="text-2xl font-bold text-slate-900 dark:text-white">
                  Additional Notes
                </h2>
                <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                  Important rollout guidance.
                </p>

                <ul className="mt-6 space-y-4">
                  {[
                    "No functional disruptions expected; changes are non-breaking and backward compatible",
                    "Improvements are focused on extensibility, visibility, and operational control",
                    "No additional training required; enhancements are intuitive and incremental",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span className="mt-1 h-2 w-2 rounded-full bg-orange-500" />
                      <span className="text-sm leading-6 text-slate-600 dark:text-slate-300">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Summary (only one highlight card — keeps focus) */}
              <div className="rounded-2xl bg-gradient-to-br from-orange-500 to-red-600 p-6 text-white shadow-lg">
                <h3 className="text-xl font-bold">Release Summary</h3>

                <p className="mt-3 text-sm leading-6 text-white/90">
                  This release enhances monitoring, alerting, dashboards, licensing, and Oracle
                  observability — while keeping the experience clean, fast, and intuitive.
                </p>

                <div className="mt-5 text-sm font-semibold">Status: Ready for adoption</div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}